define('views/components/product/product_list',['require','views/base/list_view','views/components/product/product','text!templates/components/product/product_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/product/product');

    var temp = require("text!templates/components/product/product_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

